import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';

export class EventTemplateAttributeInput implements ViewModel {
  readonly friendlyTypeNameSingular = 'Event Template Attribute Input';
  readonly apiRoute: string = CONFIG.apiRoutes.eventTemplateAttribute;

  id: string;
  eventId: string;
  eventTemplateAttributeId: string;
  value: string;

  json(): any {
    return this;
  }

  loadFromJson(data: any): void {
    this.id = data.id;
    this.eventId = data.eventId;
    this.eventTemplateAttributeId = data.eventTemplateAttributeId;
    this.value = data.value;
  }
}
